import { useMemo } from 'react';

import { type BrandVoiceFormatGroup } from 'src/data/format';
// @ts-expect-error - no TypeScript definitions yet
import { useBrandVoicesAssets } from 'src/store/brandVoices';

export const useHaveEnabledFormatGroups = (): boolean => {
  const { customFormatGroups } = useBrandVoicesAssets();

  return useMemo<boolean>(
    () => customFormatGroups.some((fg: BrandVoiceFormatGroup) => fg.on),
    [customFormatGroups]
  );
};
